module.exports = __webpack_public_path__ + "static/media/ios-4.efc3a3dd.jpg";